module.exports = __webpack_public_path__ + "static/media/icon_beginner.9c54883f.svg";